import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as HMS from "../../../common/component/Index";
import * as Tour from "../component/CommonComponent";
import { message, Tooltip, Icon, Tabs, Upload } from 'antd';
import DEFINE, {UPLOAD_DIRECTORY} from "../../../../../constants/Define";
import $ from "jquery";
import { Modal, Button } from 'antd';
import Input from '../../../common/component/Input';
import Wrapper from '../../../common/component/Wrapper';
import RichTextEditor, { ClassicEditor } from '../../../common/component/RichTextEditor';
import TextArea from '../../../common/component/TextArea';
import UploadImage from '../../../common/component/UploadImage';
import './styles.less';
const { TabPane } = Tabs;

class ActionTour extends Component {

    state = {
        action: "CREATE",
        data: { isSpecial: false },
        isSubmit: false,
        isGetItem: false,
        isDisableStation: false,
        arrayData: [],
        arrayDepartureDate: [0],
        arrayDepartureOnSave: [],
        validation: {},
        isFetching: false,
        isFetchingUpdate: false,
        isUpload: false,
        isUploadMultiple: false,
        fileMultiple: [],
        editKey: -1,
        validationTourLine: {},
        validationTourLinePrice: {},
        thumbImage: {},
        isShowModal: false,
        multiDepartureData: { prices: [{ priceType: "ADULT" }], tourId: this.props.match.params.id },
    };

    onDeletePrice = (priceType) => {
        let newItem = this.state.tourLineItems;
        let newPrice = this.state.tourLineItems[0].prices.filter(p => p.priceType !== priceType);
        this.state.tourLineItems.prices = newPrice;
    };

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: "UPDATE" });
            this.props.onGetItemUser({ id: match.params.id, props: this.props });
        }
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                minLength: { phoneNumber: t('validation.minPhone'), password: t('validation.minpassword') },
                maxLength: { images: Func.formatValidation(t('validation.statusCode.code.9'), 6) },
                isPhone: { phoneNumber: t('validation.isPhone') },
                isEmail: { email: t('validation.email') },
                isSpecialString: { username: t('validation.isSpecialString') },
                isWhieSpace: { username: t('validation.isSpecialString') },
                strongPassword: { password: t('validation.password') },
                maxValueNumber: {
                    adultSalePrice: Func.formatValidation(t('validation.statusCode.code.8'), t(`item.tour.adultOriginalPrice`)),
                },
                minValueNumber: {
                    //days: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.days`)),
                    // nights: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.nights`)),
                },
                required: {
                    title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.title`)),
                    //tourCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.tourCode`)),
                    adultOriginalPrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.adultOriginalPrice`)),
                    adultSalePrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.adultSalePrice`)),
                    //groupSize: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.groupSize`)),
                    //days: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.days`)),
                    // nights: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.nights`)),
                    //departure: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.departure`)),
                    //destination: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.destination`)),
                }
            };
            let valueValidate = {
                minLength: { phoneNumber: 8, password: 6 },
                maxLength: { images: 6 },
                maxValueNumber: {
                    adultSalePrice: this.state.data.adultOriginalPrice,
                },
                minValueNumber: {
                    //days: 1,
                    // nights: 1
                },
            };
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.tours.isSubmit,
            isGetItem: nextProps.tours.isGetItem,
            isFetchingUpdate: nextProps.tours.isFetchingUpdate,
            isUpload: nextProps.file.isFetching,
            isUploadMultiple: nextProps.file.isFetchingMultiple,
            isShowModal: nextProps.tours.isShowModal
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.file !== prevProps.file) {
            if (this.props.file.file) {
                let fileMulti = this.state.fileMultiple;
                let fileNameMulti = this.state.data.images ? this.state.data.images : [];
                let oldThumbImage = this.state.thumbImage;
                let thumbImageName = this.state.data.thumbImage ? this.state.data.thumbImage : "";
                if (this.props.file.file.type === 1) {
                    fileMulti.push(this.props.file.file.data);
                    fileNameMulti.push(this.props.file.file.data.fileName)
                }
                else if (this.props.file.file.type === 0) {
                    oldThumbImage = this.props.file.file.data;
                    thumbImageName = this.props.file.file.data.fileName;
                }
                this.setState({
                    file: this.props.file.file.type === 0 ? this.props.file.file : undefined,
                    data: {
                        ...this.state.data,
                        thumbImage: thumbImageName,
                        images: fileNameMulti
                    },
                    fileMultiple: fileMulti,
                    thumbImage: oldThumbImage,
                });
            }
        }
        if (this.props.tours.dataUpdate !== prevProps.tours.dataUpdate) {
            this.setState({
                action: "UPDATE"
            })
            let data = this.props.tours.dataUpdate;
            let images = this.props.tours.dataUpdate.tourDetail.images;
            let listImages = this.props.tours.dataUpdate.tourDetail.imageViews;
            let thumbImage = this.props.tours.dataUpdate.tourDetail.thumbImageView;
            data = { ...data, ...data.tourDetail };
            data = Func.removeArrayElementObject(data, ['tourDetail', 'imageViews']);
            let arrayImages = [];
            listImages.map(i => arrayImages.push({ fileUrl: i.fileUri, fileName: i.filename }));
            this.setState({
                data: data,
                fileMultiple: arrayImages,
                arrayData: this.props.tours.dataUpdate.tourLineItems,
                thumbImage: thumbImage
            })
        }
    }

    onChangeArray = (e, count, departure) => {
        if (e) {
            let params = Func.getValueForm(e);
            if (params.name === 'departureDate') {

                let oldArray = this.state.arrayData;
                let lineData = oldArray[count];
                lineData = {
                    ...lineData,
                    from: params.value[0],
                    to: params.value[1]
                }
                oldArray[count] = lineData;
                this.setState({
                    arrayData: oldArray
                });
            } else {
                let oldArray = this.state.arrayData;
                let lineData = oldArray[count];
                lineData = { ...lineData, [params.name]: Func.convertStringToNumber(params.value, params.name, ['seat', 'originalPrice', 'salePrice']) }
                oldArray[count] = lineData;
                this.setState({
                    arrayData: oldArray
                });
            }
        } else {
            this.setState({
                arrayData: {
                    ...this.state.arrayData,
                    [count]: {
                        ...this.state.arrayData[count],
                        prices: departure
                    },
                }
            })
        }
    };

    onChange = (e, tag) => {
        if (tag) {
            this.setState({
                data: {
                    ...this.state.data,
                    [tag]: e
                }
            });
            this.validation(tag, true)
        } else {
            let params = Func.getValueForm(e);
            this.setState({
                data: {
                    ...this.state.data,
                    [params.name]: Func.convertStringToNumber(params.value, params.name, ['adultOriginalPrice', 'adultSalePrice', 'days', 'nights', 'limitNumberOfSale'])
                }
            });
            this.validation(params.name, true)
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            let data = this.state.data;
            let dataSubmit = {
                days: data.days,
                nights: data.nights,
                adultOriginalPrice: data.adultOriginalPrice,
                adultSalePrice: data.adultSalePrice,
            };
            data = Func.removeArrayElementObject(data, ['days', 'nights', 'adultOriginalPrice', 'adultSalePrice']);
            dataSubmit = {
                ...dataSubmit,
                tourDetail: data
            };
            if (this.state.action === "CREATE") {
                // let dataCreate = Models.usersActionModel(this.state.data);
                // if(this.state.isDisableStation){
                //     dataCreate = Func.removeElementObject(dataCreate, 'stationId')
                // }
                this.props.onCreateTour({ data: dataSubmit, props: this.props });
            } else if (this.state.action === "UPDATE") {
                // let dataUpdate = Models.usersActionModel(this.state.data);
                // if(this.state.isDisableStation){
                //     dataUpdate = Func.removeElementObject(dataUpdate, 'stationId')
                // }
                dataSubmit = Func.removeArrayElementObject(dataSubmit, 'imageViews');
                this.props.onUpdateTour({ data: { ...dataSubmit, id: this.props.match.params.id }, props: this.props });
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    onAppendDepartureDate = () => {
        var oldArray = this.state.arrayData;
        oldArray.push({ prices: [] });
        this.setState({
            arrayData: oldArray
        })
        this.setState({ editKey: this.state.arrayData.length - 1 })
    };

    uploadFile = (file) => {
        let data = this.state.data;
        data = Func.removeElementObject(data, 'avatar');
        this.setState({
            isUpload: true,
            data: data
        });
        this.props.onUploadFile({ file: file.target.files[0], directory: UPLOAD_DIRECTORY.TOUR_THUMB, isFile: 1 });
    };

    uploadFileMultiple = (file) => {
        let data = file.target.files;
        let lengthImage = this.state.fileMultiple;
        if (data.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        if ((lengthImage.length + data.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        this.setState({
            isUploadMultiple: true,
        });
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(data).map((i) => {
            if (imageValidation.includes(data[i].type)) {
                this.props.onUploadFile({ file: data[i], directory: "tours", isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    };

    validationTourLine = (field, reload, keyParent) => {
        let result = {};
        const { t } = this.props;
        if (!reload) {
            let data = this.state.arrayData[keyParent];
            let validate = {
                minValueNumber: {
                    seat: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.days`)),
                },
                required: {
                    seat: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.destination`)),
                }
            };
            let valueValidate = {
                minValueNumber: {
                    seat: 1,
                },
            };
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validationTourLine;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validationTourLine: result });
        return result;
    };


    validationTourLinePrice = (field, reload, keyParent, keyPrice) => {
        let result = {};
        const { t } = this.props;
        if (!reload) {
            let data = this.state.arrayData[keyParent].prices[keyPrice];
            let validate = {
                maxValueNumber: {
                    adultSalePrice: Func.formatValidation(t('validation.statusCode.code.8'), t(`item.tour.adultOriginalPrice`)),
                },
                minValueNumber: {
                    days: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.days`)),
                },
                required: {
                    seat: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.destination`)),
                    originalPrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.destination`)),
                    salePrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.destination`)),
                }

            };
            let valueValidate = {
                minLength: { phoneNumber: 8, password: 6 },
                maxLength: { images: 6 },
                maxValueNumber: {
                    adultSalePrice: this.state.data.adultOriginalPrice,
                },
                minValueNumber: {
                    days: 1,
                },
            };
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {

            let data = this.state.arrayData[keyParent].prices[keyPrice];

            let validation = this.state.validationTourLinePrice;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validationTourLinePrice: result });
        return result;
    };

    onSaveDeparture = (count) => {
        let dataSubmit = this.state.arrayData[count];
        var result = this.validationTourLine('seat', false, count);
        if (Object.keys(result).length < 1) {
            this.setState({ editKey: -1 });
            if (dataSubmit.id) {
                this.props.onUpdateTourLine({ data: dataSubmit });
            }
            else {
                dataSubmit = { ...this.state.arrayData[count], tourId: this.props.match.params.id };
                this.props.onCreateTourLine({ data: dataSubmit });
            }
        }

    };

    onRemoveSaveDeparture = (count) => {
        if (this.state.editKey == count) {
            this.setState({ editKey: -1 });
        }
        else {
            this.setState({ editKey: count });
        }
    };

    removeItem = (i) => {
        if (i.id) {
            this.props.onDeleteTourLine({ id: i.id });
        }
        let newArray = this.state.arrayData;
        newArray = Func.arrayRemoveItem(newArray, i);
        this.setState({
            arrayData: newArray,
        });
        this.setState({ editKey: -1 });
    };

    render() {
        const { t } = this.props;
        const { multiDepartureData, isShowModal, editKey, data, validation, isSubmit, isGetItem, action, isFetchingUpdate, arrayDepartureDate, arrayDepartureOnSave, arrayData, isUpload, file, fileMultiple, isUploadMultiple } = this.state;
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit || isFetchingUpdate || isGetItem}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'tours'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.tour.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.tour.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            submitButtonRight={true}
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('tours', this.props)}
                            titleBack={t('action.back')}
                            activeComponent={true}
                            statusActiveName={`isSpecial`}
                            onChangeActive={this.onChange}
                            titleActiveComponent={t(`item.tour.isSpecial`)}
                            statusActive={data.isSpecial}
                        >
                            <HMS.FormWrapperItem>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.title}
                                        validation={validation.title}
                                        labelTitle={t(`item.tour.tourTitle`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`title`} onChange={this.onChange}
                                            value={Func.checkUndefine(data.title)} />
                                    </HMS.FormWrapperInputComponent>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.tourCode}
                                                // validation={validation.tourCode}
                                                labelTitle={t(`item.tour.tourCode`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`tourCode`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.tourCode)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.groupSize}
                                                // validation={validation.groupSize}
                                                labelTitle={t(`item.tour.groupSize`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`groupSize`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.groupSize)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.adultOriginalPrice}
                                                validation={validation.adultOriginalPrice}
                                                labelTitle={t(`item.tour.adultOriginalPrice`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`adultOriginalPrice`} onChange={this.onChange}
                                                    value={Func.formatMoney(Func.checkUndefine(data.adultOriginalPrice))} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.adultSalePrice}
                                                validation={validation.adultSalePrice}
                                                labelTitle={t(`item.tour.adultSalePrice`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`adultSalePrice`} onChange={this.onChange}
                                                    value={Func.formatMoney(Func.checkUndefine(data.adultSalePrice))} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-md-6`}>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.hotel}
                                                // validation={validation.hotel}
                                                labelTitle={t(`item.tour.hotel`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`hotel`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.hotel)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.tour.limitNumberOfSale`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`limitNumberOfSale`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.limitNumberOfSale)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.days}
                                                // validation={validation.days}
                                                labelTitle={t(`item.tour.days`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`days`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.days)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.tour.nights`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`nights`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.nights)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className={`row`}>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.departure}
                                                // validation={validation.departure}
                                                labelTitle={t(`item.tour.departure`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`departure`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.departure)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className={`col-md-6`}>
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                // isValidation={true}
                                                // dataValidation={data.destination}
                                                // validation={validation.destination}
                                                labelTitle={t(`item.tour.destination`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`destination`} onChange={this.onChange}
                                                    value={Func.checkUndefine(data.destination)} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                            </HMS.FormWrapperItem>
                            <div style={{ height: '15px', width: '100%' }}></div>
                            <h3 className={`ml-3`}>Thông tin hành trình</h3>
                            {/*
                            <Tabs defaultActiveKey="1" onChange={this.onChangeTab} type="card"
                                  className={` ibox-content col-md-12`}>
                                <TabPane tab="Dịch vụ & thông tin hành trình" key="1"> */}
                            <Wrapper defaultactivekey="1" onChange={this.onChangeTab} type="card"
                                className={` ibox-content col-md-12`} style={{overflow: 'hidden'}}>
                                <div className={`row`}>
                                    <div className={`col-md-6`}>
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.tour.serviceIncluded`)}
                                        >
                                            <TextArea
                                                className="form-control" name="serviceIncluded" onChange={this.onChange}
                                                value={data.serviceIncluded ? data.serviceIncluded : ""} />
                                        </HMS.FormWrapperInputComponent>
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.tour.serviceExcluded`)}
                                        >
                                            <TextArea
                                                className="form-control" name="serviceExcluded" onChange={this.onChange}
                                                value={data.serviceExcluded ? data.serviceExcluded : ""} />
                                        </HMS.FormWrapperInputComponent>
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.tour.cancelCondition`)}
                                        >
                                            <TextArea
                                                className="form-control" name="cancelCondition" onChange={this.onChange}
                                                value={data.cancelCondition ? data.cancelCondition : ""} />
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                    <div className={`col-md-6`}>
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.tour.checklist`)}
                                        >
                                            <TextArea
                                                className="form-control" name="checklist" onChange={this.onChange}
                                                value={data.checklist ? data.checklist : ""} />
                                        </HMS.FormWrapperInputComponent>
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.tour.note`)}
                                        >
                                            <TextArea
                                                className="form-control" name="note" onChange={this.onChange}
                                                value={data.note ? data.note : ""} />
                                        </HMS.FormWrapperInputComponent>
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.tour.description`)}
                                        >
                                            <TextArea
                                                className="form-control" name="description" onChange={this.onChange}
                                                value={data.description ? data.description : ""} />
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                </div>
                                {/* </TabPane> */}
                                {/* <TabPane tab="Lịch trình & Điểm nổi bật" key="2"> */}
                                <div className={`row`}>
                                    <div className={`col-md-6`}>
                                        <HMS.FormWrapperInputComponent
                                            // isRequired={true}
                                            // isValidation={true}
                                            // dataValidation={data.tourTitle}
                                            // validation={validation.tourTitle}
                                            labelTitle={t(`item.tour.highlight`)}
                                        >
                                            <RichTextEditor
                                                editor={ClassicEditor}
                                                data={data.highlight || ""}
                                                config={{uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB}}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    this.onChange(data, "highlight")
                                                }}
                                            />
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                    <div className={`col-md-6`}>
                                        <HMS.FormWrapperInputComponent
                                            // isRequired={true}
                                            // isValidation={true}
                                            // dataValidation={data.tourTitle}
                                            // validation={validation.tourTitle}
                                            labelTitle={t(`item.tour.itinerary`)}
                                        >
                                            <RichTextEditor
                                                editor={ClassicEditor}
                                                data={data.itinerary || ""}
                                                config={{uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB}}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    this.onChange(data, "itinerary")
                                                }}
                                            />
                                        </HMS.FormWrapperInputComponent>
                                    </div>
                                </div>
                                {/* </TabPane> */}
                                {/* </Tabs> */}

                            </Wrapper>
                            <h3 className={`ml-3 mt-3`}>Hình ảnh hành trình</h3>
                            <HMS.FormWrapperItem classParent={`tour-upload-zone`}>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        // isRequired={true}
                                        // isValidation={true}
                                        // dataValidation={data.avatar}
                                        // validation={validation.avatar}
                                        labelTitle={t(`item.tour.thumpImage`)}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            loading={isUpload}
                                            thumbnailSize="100%"
                                            buttonSize={120}
                                            thumbnailStyle={{ maxHeight: 250 }}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFile}
                                            onRemoveThumbnail={this.removeThumbImage}
                                            thumbnails={this.getThumbSources([this.state.thumbImage])} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        // isRequired={true}
                                        // isValidation={true}
                                        // dataValidation={data.avatar}
                                        // validation={validation.avatar}
                                        labelTitle={t(`item.tour.images`)}
                                    >
                                        {/* <HMS.LoadingComponent spinning={isUploadMultiple}>
                                            <label
                                                className={`file-upload ${this.showImageMultiple().length > 6 ? "hide" : "btn btn-info"}`}>
                                                {t('item.tour.uploadFile')} ... <input type="file" name={`fileMultiple`}
                                                    multiple
                                                    onChange={this.uploadFileMultiple}
                                                    className="uploadFile" />
                                            </label>
                                            <div className={`row`}>
                                                {
                                                    this.showImageMultiple()
                                                }
                                            </div>
                                        </HMS.LoadingComponent> */}
                                        <UploadImage
                                            multiple={true}
                                            loading={isUploadMultiple}
                                            thumbnailSize={120}
                                            buttonSize={120}
                                            disabledUpload={this.showImageMultiple().length > 6}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFileMultiple}
                                            onRemoveThumbnail={(src, index) => this.removeImage(this.getImageThumbBySrc(src))}
                                            thumbnails={this.getThumbSources(this.state.fileMultiple || [])} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                        {/* CREATE TOUR LIST ITEM */}
                        {
                            action === "UPDATE" && (
                                <Fragment>
                                    <h3 className={`ml-3`}>Ngày khởi hành - Ngày kết thúc</h3>
                                    {
                                        arrayData && arrayData.length > 0 && arrayData.map((i, k) => {
                                            return (<div key={k}>
                                                <Tour.DepartureDateOnSave count={i} data={i}
                                                    tourData={data}
                                                    disabled={arrayDepartureOnSave.includes(k)}
                                                    onRemoveSaveDeparture={() => this.onRemoveSaveDeparture(k)} />


                                                <Tour.DepartureDateComponent count={k} arrayData={i}
                                                    removeItem={(item) => this.removeItem(i)}
                                                    data={data}
                                                    disabled={editKey != k}
                                                    onSaveDeparture={(count) => this.onSaveDeparture(count)}
                                                    onChange={(e, departure) => this.onChangeArray(e, k, departure)}
                                                    onRemovePrice={(i, count) => this.onRemovePrice(i, count)}
                                                    onAddPrice={(i, count) => this.onAddPrice(i, count)}
                                                    onChangePrice={(count, k, params) => this.onChangePrice(count, k, params)}
                                                    onRemoveSaveDeparture={() => this.onRemoveSaveDeparture(k)}
                                                />
                                            </div>
                                            )
                                        })
                                    }
                                    <button type={`button`} className="btn btn-primary mb-3"
                                        onClick={this.onAppendDepartureDate}>+
                                    Thêm hành trình
                                        </button>
                                    <span>
                                        <button type={`button`} className="btn btn-primary mb-3 ml-3"
                                            onClick={this.onShowModel}>+
                                        Thêm nhiều hành trình
                                            </button>
                                        <Modal
                                            title="Thêm nhiều hành trình"
                                            visible={isShowModal}
                                            okText="Tạo mới"
                                            cancelText="Hủy"
                                            width={800}
                                            onOk={this.onSaveMultiple}
                                            onCancel={this.onCloseModel}
                                            confirmLoading={isSubmit}>
                                            <Tour.MultipleDepartureComponent
                                                isSubmit={isSubmit}
                                                multiDepartureData={multiDepartureData}
                                                onSetMultipleState={(val) => this.onSetMultipleState(val)}
                                            />
                                        </Modal>
                                    </span>
                                </Fragment>
                            )
                        }
                        {/* END CREATE TOUR LIST ITEM */}
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }

    onSetMultipleState = (val) => {
        this.setState({ multiDepartureData: val })
    }

    onSaveMultiple = () => {
        this.props.onCreateMultipleTourLine({ data: this.state.multiDepartureData });
    }

    onCloseModel = () => {
        this.setState({ isShowModal: false })
    }

    onShowModel = () => {
        this.setState({ isShowModal: true })
    }

    onChangePrice = (count, k, params) => {
        let oldArray = this.state.arrayData;
        let lineData = oldArray[count];
        let oldPrices = lineData.prices;
        let linePrice = oldPrices[k]
        linePrice = { ...linePrice, [params.name]: Func.convertStringToNumber(params.value, params.name, ['salePrice', 'originalPrice']) }
        oldPrices[k] = linePrice;
        lineData.prices = oldPrices;
        oldArray[count] = lineData;
        this.setState({
            arrayData: oldArray
        })
    }

    onRemovePrice = (i, count) => {
        let oldArray = this.state.arrayData;
        let newPrice = Func.arrayRemoveItem(oldArray[count].prices, i);
        oldArray[count].prices = newPrice;
        this.setState({
            arrayData: oldArray
        })
    }

    onAddPrice = (i, count) => {
        let oldArray = this.state.arrayData;
        oldArray[count].prices.push(i);
        this.setState({
            arrayData: oldArray
        })
    }

    showImageMultiple() {
        let data = this.state.fileMultiple;
        let arrayImg = [];
        if (data.length > 0) {
            data.map((i, k) => {
                arrayImg.push(
                    <div className={`col-md-2`} style={{ position: 'relative' }} key={k}>
                        <Icon type={'close'} className={`cursorPointer removeImage`}
                            onClick={() => this.removeImage(i, k)} />
                        <img key={k}
                            src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${i.fileUrl}`}
                            width={`100%`}
                            className={`cursorPointer img-thumbnail ml-3`} />
                    </div>
                )
            })
        }
        return arrayImg;
    }

    showThumbImage() {
        let data = this.state.thumbImage;
        if (this.state.thumbImage && Object.keys(this.state.thumbImage).length > 0) {
            return (
                <div className={`col-md-2`} style={{ position: 'relative' }}>
                    <Icon type={'close'} className={`cursorPointer removeImage`}
                        onClick={() => this.removeThumbImage()} />
                    <img
                        src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${data.fileUri ? data.fileUri : data.fileUrl}`}
                        width={`100%`}
                        className={`cursorPointer img-thumbnail ml-3`} />
                </div>
            )
        }
    }

    getThumbSources(thumbs) {
        return thumbs.filter(t => t && Object.keys(t).length > 0).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.fileUri ? t.fileUri : t.fileUrl}`)
    }

    getImageThumbBySrc(src) {
        const founds = (this.state.fileMultiple || []).filter(item => (src || '').endsWith(item.fileUri ? item.fileUri : item.fileUrl))
        return founds && founds.length && founds[0]
    }

    removeImage = (i, k) => {
        if (!i) return;
        let images = this.state.data.images ? this.state.data.images : [];
        let oldArrayImages = this.state.fileMultiple;
        images = Func.arrayRemoveItem(images, i.fileName);
        let newOldArrayImages = [];
        if (oldArrayImages.length > 0) {
            oldArrayImages.filter(i2 => i2.fileName !== i.fileName && newOldArrayImages.push(i2));
        }
        this.setState({
            fileMultiple: newOldArrayImages,
            data: {
                ...this.state.data,
                images: images
            }
        })
    };

    removeThumbImage = () => {
        this.setState({
            data: {
                ...this.state.data,
                thumbImage: ""
            },
            thumbImage: {},
        })
    }

    onChangeTab = (key) => {

    };
}

const mapStateToProps = state => {
    return {
        tours: state.tourReducer,
        file: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        onCreateTour: (params) => {
            dispatch(action.createTourAction(params))
        },
        onUpdateTour: (params) => {
            dispatch(action.updateTourAction(params))
        },
        onGetItemUser: (params) => {
            dispatch(action.getUpdateTourAction(params))
        },
        onUpdateTourLine: (params) => {
            dispatch(action.updateTourLineAction(params))
        },
        onCreateTourLine: (params) => {
            dispatch(action.createTourLineAction(params))
        },
        onDeleteTourLine: (params) => {
            dispatch(action.deleteTourLineAction(params))
        },
        onCreateMultipleTourLine: (params) => {
            dispatch(action.createMultipleTourLineAction(params))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionTour)));
